export const MODAL_SCROLLBAR_TIME = 200;

export function handleEnvVars(env: Record<string, string>) {
  const devApiBaseUrl =
    env.VITE_DEV_API_BASE_URL || "https://ui-test.custody.lmax.com";

  const isProxied = env.VITE_IS_PROXIED === "true";

  return {
    devApiBaseUrl,
    isProxied,
  };
}
